import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { catchError, concatMap, first, of } from 'rxjs';
import { FormWizardSteps } from 'src/app/models/shared-models';
import { SessionService } from 'src/app/services/session.service';
import { BaseWizardComponent } from '../base-wizard.component';
import { HealthCheckService } from '../services/health-check-service';
import { AppInfoService } from '../services/appinfo-service';
import { Logger } from '../services/logger-service';


@UntilDestroy()
@Component({
  selector: 'app-pre-notification-advice',
  templateUrl: './pre-notification-advice.component.html',
  styleUrls: ['./pre-notification-advice.component.css'],
  imports: [],
})
export class PreNotificationAdviceComponent extends BaseWizardComponent implements OnInit {
  healthCheckSuccessStatus = true;
  appinfo = '';
  bannerContent: string | null = null;
  showBanner = false;

  constructor(
    private healthCheckService: HealthCheckService,
    private appInfoService: AppInfoService,
    private sessionService: SessionService,
    private logger: Logger,
    router: Router) {
    super();
  }

  ngOnInit(): void {

    this.healthCheckService.healthcheck$()
      .pipe(first(), untilDestroyed(this),
        concatMap(() => {
          this.healthCheckSuccessStatus = true;
          return this.sessionService.startOrGetSessionId$()
        }),
        catchError((err: HttpErrorResponse) => {
          this.logger.error('PreNotificationAdviceComponent error', err);
          this.healthCheckSuccessStatus = false;
          return of(false)
        }))
      .subscribe();

    this.appInfoService.appInfo$().subscribe(appInfo => this.appinfo = appInfo);    this.appInfoService.appBannerMainPage$().subscribe(
      bannerResp => {
        this.logger.info('app banner', bannerResp ?? {});
        this.bannerContent = bannerResp?.content || null;
        this.showBanner = this.featureFlag(this.FeatureFlags.ShowFrontPageBanner) && !!this.bannerContent;
      });

  }

  override next(): void {

    if (this.healthCheckSuccessStatus)
      this.router.navigate(['/', FormWizardSteps.LandHolderConfirmation]);
  }
}
